import i18n from '@/plugins/i18n'

export default {
    path: '/' + i18n.t('dashboard.routes.index'),
    name: 'dashboard',
    child: false,
    component: () =>
        import(
            /* webpackChunkName: "overview" */ '@/views/dashboard/Overview.vue'
        ),
    meta: {
        requiresAuth: true,
        showName: 'Dashboard',
    },
}
